import { ApiState, Action } from '../../../../types';
import { serviceReducer, callService } from '../../../../shared/hooks/serviceReducer';
import { OpMember } from '../../../../services/types/Member';

export type SearchUserAction =
  | Action<OpMember[], { query: string }>
  | {
      type: 'QUERY_MEMBER';
      query: string;
    };

const reducer = (
  state: ApiState<OpMember[], { query: string }>,
  action: SearchUserAction
): ApiState<OpMember[], { query: string }> => {
  switch (action.type) {
    case 'QUERY_MEMBER': {
      return callService(state, { query: action.query });
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
